<div class="tw-relative tw-flex tw-flex-col tw-rounded-t-7.5 tw-bg-white tw-px-6 tw-pb-4 tw-pt-12">
  <div class="tw-absolute tw-right-4 tw-top-4 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100"
    id="close-location-sheet-btn"
    role="button"
    (click)="close()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-500"
      [iconName]="'close'"></cs-icon>
  </div>

  <p class="tw-font-lexend tw-text-300 tw-font-normal tw-uppercase tw-leading-normal tw-text-gray-800"
    i18n="@@beforeWeMoveAhead">Before we move ahead</p>
  <div class="tw-mt-1 tw-font-lexend tw-text-800 tw-font-bold tw-leading-1.2 tw-text-gray-800"
    i18n="@@helpsToKnowYourCity"> It helps to <br/> know your city </div>

  <p class="tw-mt-8 tw-font-body tw-text-100 tw-font-normal tw-uppercase tw-tracking-wider tw-text-gray-800"
    i18n="@@forEg">For eg.</p>
  <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-2"
    [class.tw-flex-col-reverse]="showHairFirst">
    <app-location-example-card [iconSrc]="'/assets/icons/delhi.svg'">
      <ng-container i18n="@@delhiPollution">Delhi’s pollution is a major factor behind pigmentation</ng-container>
    </app-location-example-card>
    <app-location-example-card [iconSrc]="'/assets/icons/bangalore.svg'">
      <ng-container i18n="@@bangaloreHardWater">Bangalore’s hard water can cause heavy hair fall</ng-container>
    </app-location-example-card>
  </div>

  <div class="tw-mt-16 tw-flex tw-flex-col">
    <button csButton
      id="location-btn"
      type="button"
      class="tw-w-full"
      [loading]="loading()"
      (click)="useMyLocation()"><span i18n="@@useMyLocation">Use my location</span>
    </button>
    <button csButton="muted"
      id="skip-location-btn"
      type="button"
      class="tw-w-full"
      [disabled]="loading()"
      (click)="skip()"><span i18n="@@skip">Skip</span>
    </button>
  </div>
</div>
